import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import MainContext from '../../context/MainContext';
import '../../styles/Content.css';

const Avatar = (props: any) => {
    const navigate = useNavigate();

    const { user, setUserTreated } = useContext(MainContext);

    // const handleOnClick = () => {
    //     if (props.user?.id === user?.id) {
    //         navigate(`/settings`);
    //     } else {
    //         setUserTreated(props.user);
    //         navigate(`/settings/user/${props.user?.id}`);
    //     }
    // };

    return (
        <div
            className='avatar'
            style={{
                height: `${props.size}px`,
                width: `${props.size}px`,
                backgroundColor: props.bgColor ? props.bgColor : '',
            }}
        >
            {false ? <div /> : <p className='avatar-initals'>{`${props.user?.name && props.user?.name.toString().slice(0, 1)}`}</p>}
        </div>
    );
};
export default Avatar;
